<template>
  <DBox
    :id="'cmp-catalog-statement-sidewindow-summary'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add_new')} ${$t('genre')}`"
    style="background-color: #f7fff2; padding: 12px"
  >
    <!-- {{summary}} -->
    <!-- <h4 style="padding:10px 8px 0px 8px;font-weight:bold">{{$dft.capHead($t('statement'))}}</h4> -->
    <div v-if="summary != {}" class="summary-container">
      <!-- <template v-if="summary.view == 'payment'">
        <div class="summary-container-row">
          <div class="summary-container-row-title">
            <p>{{ $t("balance_last_period") }}</p>
          </div>
          <div class="summary-container-row-value">
            {{ $dft.curr(summary["previous_total"]) }}
            {{ systemCurrency }}
          </div>
        </div>
        <div class="summary-container-row">
          <div class="summary-container-row-title">
            <p>{{ $t("payments") }}</p>
          </div>
          <div class="summary-container-row-value">
            {{ $dft.curr(summary["payments"]) }}
            {{ systemCurrency }}
          </div>
        </div>
      </template> -->
      <div
        class="summary-container-row"
        v-for="(item, key) in kvSummary"
        :key="key"
      >
        <div
          class="summary-container-row-title"
          :style="{
            fontWeight: item.bold ? 'bold' : 'normal',
            flex: item.key === 'vat_amount' ? '0' : '2',
          }"
        >
          <Dropdown2
            v-if="item.key === 'tax_amount'"
            deselect
            :showLabel="false"
            style="max-width: 215px; margin: -5px 0px"
            :options="taxTV"
            :selected="taxTV.find((e) => e.value == taxId)"
            :placeholder="$t('tax_group')"
            v-on:selectedChange="(e) => onDropdownChange('tax_group_id', e)"
            :bb="'0px'"
            :cw="'215px'"
          />
          <TextField2
            v-else-if="item.key === 'vat_amount'"
            :showLabel="false"
            id="vat_rate"
            style="margin: -5px 0px"
            :value="vatValue"
            :placeholder="`${$t('vat_rate')}`"
            :bb="'0px'"
            :type="'percent'"
            :cw="`clamp(40px, ${
              ((vatValue && vatValue) || 'discountpe').toString().length * 13
            }px, 250px)`"
            @change="(e) => onVatChange(e, summary)"
          />
          <p v-else>{{ $t(item.key) }}</p>
        </div>
        <div
          class="summary-container-row-value"
          :style="{
            fontWeight: item.bold ? 'bold' : 'normal',
            color: item.bold ? '#282828' : 'inherit',
          }"
        >
          {{ $dft.curr(item.value) }}
          {{ systemCurrency }}
        </div>
      </div>

      <!-- <div class="summary-container-row">
        <div class="summary-container-row-title">
          <p>{{ $t("opening_balance") }}</p>
        </div>
        <div class="summary-container-row-value">
          {{ $dft.curr(summary["opening_balance"]) }}
          {{ systemCurrency }}
        </div>
      </div>
      <div class="summary-container-row">
        <div class="summary-container-row-title">
          <p>{{ $t("deductions") }}</p>
        </div>
        <div class="summary-container-row-value">
          {{ $dft.curr(summary["deductions"]) }}
          {{ systemCurrency }}
        </div>
      </div>
      <div class="summary-container-row">
        <div class="summary-container-row-title">
          <p>{{ $t("royalty_amount") }}</p>
        </div>
        <div class="summary-container-row-value">
          {{ $dft.curr(summary["royalty_amount"]) }}
          {{ systemCurrency }}
        </div>
      </div>
      <div class="summary-container-row">
        <div style="font-weight: bold" class="summary-container-row-title">
          <p>{{ $t("minimum_payment") }}</p>
        </div>
        <div
          style="font-weight: bold; color: #282828"
          class="summary-container-row-value"
        >
          {{ summary["minimum_payment"] }} {{ systemCurrency }}
        </div>
      </div> -->
      <!-- <template v-if="parseInt(summary.payment_flag) == 1">
        <div class="summary-container-row">
          <div class="summary-container-row-title">
            <Dropdown2
              deselect
              :showLabel="false"
              style="max-width: 215px; margin: -5px 0px"
              :options="taxTV"
              :selected="taxTV.find((e) => e.value == taxId)"
              :placeholder="$t('Tax Group')"
              v-on:selectedChange="(e) => onDropdownChange('tax_group_id', e)"
              :bb="'0px'"
              :cw="'215px'"
            />
          </div>
          <div class="summary-container-row-value">
            {{ summary["tax_amount"] }} {{ systemCurrency }}
          </div>
        </div>
        <div class="summary-container-row">
          <div class="summary-container-row-title">
            <p>{{ $t("net_amount") }}</p>
          </div>
          <div class="summary-container-row-value">
            {{ summary["net_amount"] }} {{ systemCurrency }}
          </div>
        </div>
        <div class="summary-container-row">
          <div style="flex: 0" class="summary-container-row-title">
            <TextField2
              :showLabel="false"
              id="vat_rate"
              style="margin: -5px 0px"
              :value="vatValue"
              :placeholder="`${$t('vat_rate')}`"
              :bb="'0px'"
              :type="'percent'"
              :cw="`clamp(40px, ${
                ((vatValue && vatValue) || 'discountpe').toString().length * 13
              }px, 250px)`"
              @change="(e) => onVatChange(e, summary)"
            />
          </div>
          <div class="summary-container-row-value">
            {{ summary["vat_amount"] }} {{ systemCurrency }}
          </div>
        </div>
        <div class="summary-container-row">
          <div style="font-weight: bold" class="summary-container-row-title">
            <p>{{ $t("amount_payable") }}</p>
          </div>
          <div
            style="font-weight: bold; color: #282828"
            class="summary-container-row-value"
          >
            {{ summary["amount_payable"] }} {{ systemCurrency }}
          </div>
        </div>
      </template>
      <template v-else>
        <div class="summary-container-row">
          <div style="font-weight: bold" class="summary-container-row-title">
            <p>{{ $t("closing_balance") }}</p>
          </div>
          <div
            style="font-weight: bold; color: #282828"
            class="summary-container-row-value"
          >
            {{ summary["closing_balance"] }} {{ systemCurrency }}
          </div>
        </div>
      </template> -->
    </div>

    <div class="ut-flex" style="padding: 8px 8px 0px 8px; font-weight: bold">
      <p v-if="invoice.invoice_ref" style="flex: 1; margin-bottom: 0px">
        {{ $t("credit_note") }}
        <span class="ut-link ut-text-accent5" @click="onInvoiceRefClick">
          {{ invoice.invoice_ref }}</span
        >
      </p>
      <p v-else style="flex: 1; margin-bottom: 0px">
        {{ $t("not_credit_created") }}
      </p>
      <div
        class="dt-icon-container"
        style="flex-direction: row; justify-content: flex-end; flex: 1"
      >
        <img
          style="margin-top: 5px"
          @click.stop="onSendEmail"
          src="static/icons/email-blue.svg"
          class="dt-icon v5 s2"
        />
        <span
          @click.stop="onSendEmail"
          class="ut-link ut-text-accent5"
          style="font-weight: lighter; margin-top: 4px"
          >{{ $t("send_mail") }}</span
        >
      </div>
    </div>
    <!-- <p style="padding:20px">
                {{selectedStatementDetails.response}}
            </p> -->
    <div style="margin-top: 18px; margin-bottom: 10px" class="ut-flex ut-jend">
      <button
        style="margin-right: 0px"
        class="dt-button v5 s8"
        @click="onShowStatmentClick"
      >
        Show Statement
      </button>

      <button
        style="margin-right: 0px"
        @click="onChangeClosing"
        v-if="
          summary.view != 'payment' &&
          parseInt(
            selectedStatementDetails.response.show_change_payment_closing_btn
          ) == 1
        "
        class="dt-button v5 s8"
      >
        Change Payment /Closing
      </button>

      <!-- if ref=payment
                show enter shit
                else if !invoice - show create invoice -->

      <button
        v-if="invoiceProject && reg.test(invoiceProject.royalty_ref)"
        @click="onCreateCredit"
        class="dt-button v5 s8"
      >
        Enter Payment
      </button>

      <template v-else>
        <button
          v-if="invoiceProject.royalty_ref != ''"
          @click="onCreateCredit"
          class="dt-button v5 s8"
        >
          Create Credit Note
        </button>
      </template>
    </div>

    <!-- <div style="padding:30px 10px 0px 10px;font-weight:bold" class="ut-flex ut-jend">
                
               
                <p style="flex:1">{{$t('credit_note')}}s <span class="ut-link ut-text-accent5" @click="onInvoiceRefClick"> {{invoice.invoice_ref}}</span></p>
                <div class="dt-icon-container" style="flex-direction:row;width:100%;justify-content: flex-end;">
                    <img @click.stop="onSendEmail" src="static/icons/email-blue.svg" class="dt-icon v5 s2"/> 
                    <span @click.stop="onSendEmail" class="ut-link ut-text-accent5" style="font-weight:lighter;margin-top: 4px;" >{{$t('send_mail')}}</span>
                </div>
                <div  class="ut-flex" style="flex-direction:column; flex:1;margin-top:-15px">
                  
                    <div   style=" width:100%;justify-content: flex-end;display:flex">
                        <button style="font-weight:lighter;margin-right:0px" class="dt-button v5 s8" @click="onShowStatmentClick">
                            Show Statement
                        </button>
                    </div>
                    
                </div>

            </div> -->
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
// import { createNTableConfig } from '../../../../plugins/datatable';
import DBox from "@dtplugins/dbox/dbox";
import { createTV } from "../../../../models/text-value.model";
import {
  costListLDTRoutes,
  invoiceListLDTRoutes,
} from "../../../accounting/router/routes";
import { StmtSummaryModel } from "../../models/stmt_summary.model";
//import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {
    selectedStatementDetails: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
  },
  data: function () {
    return {
      tax_group_id: null,
      vat_rate: 0.0,
      reg: /payments/i,
    };
  },
  computed: {
    summary: function () {
      return this.selectedStatementDetails?.response?.stmt_summary || {};
    },
    rp: function () {
      return this.selectedStatementDetails?.response?.rp || {};
    },
    invoice: function () {
      return this.selectedStatementDetails?.response?.invoice || {};
    },

    taxTV: function () {
      return createTV(
        this.selectedStatementDetails?.response?.tax_groups,
        "tax_group_name",
        "tax_group_id"
      );
    },

    taxId: function () {
      return (
        this.taxTV?.find((e) => e.text == this.summary?.tax_group_name)
          ?.value || null
      );
    },

    invoiceProject: function () {
      return this.selectedStatementDetails?.response?.invoice_project || {};
    },

    systemCurrency: function () {
      return this.$store.getters.account.client.default_currency;
    },

    vatValue: function () {
      return `${this.summary?.vat_rate}`;
    },

    kvSummary() {
      /**
        From Trello Card https://trello.com/c/SowIbcjS ---
        
        Display Order	Display Flag	
        opening_period_all	1
        ded_statement	1
        royalty_amount	1
        min_payout	1
        payment_net_all	1
          
        tax_deduction_amount	if(tax_deduction_amount <>0 ,1,0)
        vat_amount	if(vat_amount <>0 , 1 , 0)
        payment_gross_all	if(payment_flag=1 , 1 , 0)
        closing_period_all	if( coalesce(payment_flag,0)=0 , 1 , 0)


        Considering these are the Database to API Keys ---

        opening_period_all = previous_total
        ded_statement = ded_statement
        royalty_amount = royalty_amount
        min_payout = minimum_payment
        payment_net_all = net_amount
        tax_deduction_amount = tax_amount
        vat_amount = vat_amount
        payment_gross_all = gross_amount
        closing_period_all = closing_balance
        
       */

      const summary = this.summary || StmtSummaryModel();

      return (
        [
          {
            key: "previous_total",
            value: summary?.previous_total,
            flag: summary.previous_total_display_flag,
          },
          {
            key: "ded_statement",
            value: summary?.ded_statement,
            flag: summary.ded_statement_display_flag,
          },
          {
            key: "royalty_amount",
            value: summary?.royalty_amount,
            flag: summary.royalty_amount_display_flag,
          },
          {
            key: "minimum_payment",
            value: summary?.minimum_payment,
            flag: summary.minimum_payment_display_flag,
            bold: true,
          },
          {
            key: "net_amount",
            value: summary?.net_amount,
            flag: summary.net_amount_display_flag,
          },
          {
            key: "tax_amount",
            value: summary?.tax_amount,
            flag: summary.tax_amount_display_flag,
          },
          {
            key: "vat_amount",
            value: summary?.vat_amount,
            flag: summary.vat_amount_display_flag,
          },
          {
            key: "gross_amount",
            value: summary?.gross_amount,
            flag: summary.gross_amount_display_flag,
          },
          {
            key: "closing_balance",
            value: summary?.closing_balance,
            flag: summary.closing_balance_display_flag,
            bold: true,
          },
        ]?.filter((e) => e.flag === 1) || []
      );
    },

    // showChangePaymentClosingBtn

    // selectedStatementDetails.response.show_change_payment_closing_btn
  },
  methods: {
    onRightMenuClick: function (menu) {},

    onShowStatmentClick: function () {
      this.$emit("onShowStatment");
    },

    onSendEmail: function () {
      this.$emit("onSendEmail");
    },

    onChangeClosing: function () {
      this.$emit("onChangeClosing");
    },

    onCreateCredit: function () {
      this.$emit("onCreateCredit");
    },

    onInvoiceRefClick: function () {
      //invoiceListLDTRoutes
      this.$router.push({
        name: costListLDTRoutes.names.tab,
        params: {
          invoice_id: this.invoice.invoice_id,
          tab: "overview",
        },
      });
      //   this.$router.push({
      //     name: invoiceListLDTRoutes.names.tab,
      //     params: {
      //       invoice_id: this.invoice.invoice_id,
      //       tab: "overview",
      //     },
      //   });
    },

    onVatChange: function (vat, item) {
      console.log("vat,item", vat, item);
      const { name, value } = vat;
      this[name] = value;
      this.$emit("updateVatRate", { value });
    },

    onDropdownChange: function (name, value) {
      this[name] = value.value;
      this.$emit("updateTaxDeduction", value.value);
    },
  },
};
</script>
<style lang="scss">
.cmp-catalog-statement-sidewindow-summary {
  .summary-container {
    display: flex;
    flex-direction: column;
    padding: 15px 8px 15px 8px;
    color: var(--sprt-75);
    .summary-container-row {
      display: flex;
      padding: 5px 0px 6px 0px;
      border-bottom: 1px solid var(--sprt-85);
      .summary-container-row-title {
        flex: 2;
        .fc-control {
          color: var(--sprt-75);
        }
        .dropdown--main__text {
          color: var(--sprt-75);
        }
        p {
          //padding:10px 10px 0px 10px;
          margin-bottom: 0px;
        }
      }

      .summary-container-row-value {
        flex: 1;
        text-align: right;
      }
    }
  }
}
</style>
